"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _createMixin = _interopRequireDefault(require("../utils/createMixin"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getMdBreakpoint(theme, styles) {
  var styleguideBreakpoint = function styleguideBreakpoint() {
    if (typeof window === 'undefined' || !window.sgBreakpoint) {
      return (0, _styledComponents.css)(["@media (min-width:", "px){", "}"], theme.breakpoints.md, styles);
    }

    if (typeof window !== 'undefined' && (window.sgBreakpoint === 'md' || window.sgBreakpoint === 'lg' || window.sgBreakpoint === 'xl')) {
      return (0, _styledComponents.css)(["", ""], styles);
    }

    return (0, _styledComponents.css)([""]);
  };

  return styleguideBreakpoint();
}

function getLgBreakpoint(theme, styles) {
  var styleguideBreakpoint = function styleguideBreakpoint() {
    if (typeof window === 'undefined' || !window.sgBreakpoint) {
      return (0, _styledComponents.css)(["@media (min-width:", "px){", "}"], theme.breakpoints.lg, styles);
    }

    if (typeof window !== 'undefined' && (window.sgBreakpoint === 'lg' || window.sgBreakpoint === 'xl')) {
      return (0, _styledComponents.css)(["", ""], styles);
    }

    return (0, _styledComponents.css)([""]);
  };

  return styleguideBreakpoint();
}

function getXlBreakpoint(theme, styles) {
  var styleguideBreakpoint = function styleguideBreakpoint() {
    if (typeof window === 'undefined' || !window.sgBreakpoint) {
      return (0, _styledComponents.css)(["@media (min-width:", "px){", "}"], theme.breakpoints.xl, styles);
    }

    if (typeof window !== 'undefined' && window.sgBreakpoint === 'xl') {
      return (0, _styledComponents.css)(["", ""], styles);
    }

    return (0, _styledComponents.css)([""]);
  };

  return styleguideBreakpoint();
}

var md = (0, _createMixin["default"])(function (theme, styles) {
  return getMdBreakpoint(theme, styles);
});
var lg = (0, _createMixin["default"])(function (theme, styles) {
  return getLgBreakpoint(theme, styles);
});
var xl = (0, _createMixin["default"])(function (theme, styles) {
  return getXlBreakpoint(theme, styles);
});
var _default = {
  md: md,
  lg: lg,
  xl: xl
};
exports["default"] = _default;
//# sourceMappingURL=respondTo.js.map